// frontend/src/pages/settings/users-roles/api.ts
import { api } from '../../../api/client';
import type { RoleSummary, RoleDetail, RoleInput, PendingRow, UserRow, UserInput, UserPatch, SellerOption } from './types';

export const rbacApi = {
  listRoles: () => api.get<RoleSummary[]>('/rbac/roles'),
  getRole: (id: number) => api.get<RoleDetail>(`/rbac/roles/${id}`),
  createRole: (body: { name: string; description?: string; copy_from?: number }) => api.post<RoleDetail>('/rbac/roles', body),
  updateRole: (id: number, body: RoleInput) => api.put<RoleDetail>(`/rbac/roles/${id}`, body),
  deleteRole: (id: number) => api.delete<{ deleted: boolean }>(`/rbac/roles/${id}`),
  resetRole: (id: number) => api.post<RoleDetail>(`/rbac/roles/${id}/reset`, {}),
  effective: (id: number) => api.get<string[]>(`/rbac/roles/${id}/effective`),
  pending: () => api.get<PendingRow[]>('/rbac/pending'),
  pendingCount: () => api.get<{ count: number }>('/rbac/pending/count'),
  decide: (capability: string, decisions: { role_id: number; granted: boolean }[]) =>
    api.post<{ decided: boolean }>(`/rbac/pending/${encodeURIComponent(capability)}/decide`, { decisions }),
};

export const usersApi = {
  list: () => api.get<UserRow[]>('/users'),
  /** La contraseña generada vuelve UNA sola vez, en `generated_password`. */
  create: (body: UserInput) => api.post<{ user: UserRow; generated_password?: string }>('/users', body),
  update: (id: number, body: UserPatch) => api.put<UserRow>(`/users/${id}`, body),
  resetPassword: (id: number) => api.post<{ generated_password: string }>(`/users/${id}/reset-password`, {}),
  /** Vendedores para el selector: la misma fuente que usa la barra superior. */
  sellers: () => api.get<{ sellers: SellerOption[] }>('/dashboard/connections'),
};
